// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"44e28675","732":"fa00cbee","977":"b11b2377"}[chunkId] + ".chunk.js";
};